exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".item-title[data-v-17707a1a]{font-size:16px;font-weight:500;margin:10px 0}.optional-tip[data-v-17707a1a]{font-size:12px;font-weight:400;color:#999}.required-tip[data-v-17707a1a]{font-size:12px;font-weight:400;color:#f56c6c}.el-input[data-v-17707a1a],.el-select[data-v-17707a1a]{width:200px}.campus-select[data-v-17707a1a]{width:460px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-rewriter.js?id=data-v-17707a1a&scoped=true!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/views/OperationManage/SystemConfig/SystemConfig/Components/DigitalYuedongAdShield.vue
// module id = 456
// module chunks = 0